export default __webpack_public_path__ + "images/A3.671a908.png";